export const PAWP_DOMAIN = 'pawp.com'
